import { render, staticRenderFns } from "./DeliveryOrderView.vue?vue&type=template&id=5aab45df&"
import script from "./DeliveryOrderView.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports